<template>
    <!-- INICIO NEW EVENT FORM -->
    <BaseModal modalId="EditEventForm" :title="'Editar Evento'" :isVisible="true" @close="cancelar">

        <div>
            <div class="modal-body" v-if="!isMobile">

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-3">
                        <label>Edición</label>
                    </div>

                    <div class="col-4">
                        <input class="form-control form-control-sm" type="date" id="creacion_fecha" v-model="fecha">
                    </div>

                    <div class="col-3">
                        <input class="form-control form-control-sm" type="time" id="creacion_hora" v-model="hora">
                    </div>

                    <div class="col-2">
                        <button class="btn btn-secondary btn-sm" id="ahora" @click="setAhora">Ahora</button>
                    </div>
                </div>

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-3">
                        <label>Tipo</label>
                    </div>

                    <div class="col-4">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="eventTypeSelected">
                            <option v-for="tipo in eventTypes" :key="tipo.event_type_id"
                                :value="{ id: tipo.event_type_id, text: tipo.event_type }">{{
                                    tipo.event_type
                                }}</option>
                        </select>
                    </div>

                    <div class="col-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="visible">
                            <label class="form-check-label" for="flexCheckDefault">
                                Visible
                            </label>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="dynamic">
                            <label class="form-check-label" for="flexCheckDefault">
                                Dinámico
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row d-flex align-items-center mb-1">

                    <div class="col-3">
                        <label>Alcance</label>
                    </div>

                    <div class="col-4">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedScope">
                            <option v-for="alc in alcances" :key="alc">{{ alc }}</option>
                        </select>
                    </div>

                    <div class="col-2">                     
                        <label>Estado</label>
                    </div>
                    <div class="col-3">                            
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedState">
                            <option v-for="est in estados" :key="est">{{ est }}</option>
                        </select>
                    </div>

                    
                </div>

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-4">
                        <label>Ubicación</label>
                    </div>

                    <div class="col-1">
                        <label>Lat</label>
                    </div>

                    <div class="col-2">
                        <input class="form-control form-control-sm" type="text" id="lat" v-model="lat">
                    </div>

                    <div class="col-1">
                        <label>Lon</label>
                    </div>

                    <div class="col-2">
                        <input class="form-control form-control-sm" type="text" id="lon" v-model="lon">
                    </div>

                    <div class="col-1">
                        <button class="btn btn-secondary btn-sm" id="pasteCoords" @click="pasteCoords"><i
                                class="bi bi-pin-map-fill"></i></button>
                    </div>
                </div>


                <div class="row d-flex align-items-center mb-1">
                    <div class="col-3">
                        <label>Descripción</label>
                    </div>

                    <div class="col-9">
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                            v-model="descript"></textarea>
                    </div>
                </div>

                <div class="w-100 mt-3">
                    <file-uploader ref="fileUploaderRef" :show-upload-button="false" :destPath="destPath"></file-uploader>
                </div>
                <div class="row mt-3">
                    <div class="col-12 justify-content-end d-flex">
                        <button class="btn btn-danger" id="cancelar" @click="cancelar">Cancelar</button>
                        <button class="btn btn-success" id="aceptar" @click="saveEvent">Aceptar</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label>Medios asociados</label>
                        <div v-if="eventAttachments.length > 0" class="row tbl-container">
                            <div class="table-wrapper">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th></th> <!-- Columna para los íconos -->
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="media in eventAttachments" :key="media.id_event_attachment">
                                        <td><i class="bi bi-file-earmark"></i></td> <!-- Ícono para archivos -->
                                        <td>{{ media.file_name }}</td>
                                        <td>{{ formatUtc(media.utc) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <div v-else>
                            <p>No hay medios asociados.</p>
                        </div>
                    </div>
                </div>
            </div>



        <!-- Ventana mobile -->
        
         <div class="modal-body" v-if="isMobile" >
            <div class="row d-flex align-items-center mb-1">
                    <div class="col-12">
                        <label>Edición</label>
                    </div>
            </div>
            <div class="row d-flex align-items-center mb-2">
                    <div class="col-12">
                        <input class="form-control form-control-sm" type="date" id="creacion_fecha" v-model="fecha">
                    </div>
            </div>
            <div class="row d-flex align-items-center mb-3">
                    <div class="col-9">
                        <input class="form-control form-control-sm" type="time" id="creacion_hora" v-model="hora">
                    </div>

                    <div class="col-3">
                        <button class="btn btn-secondary btn-sm" id="ahora" @click="setAhora">Ahora</button>
                    </div>
                </div>

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12">
                        <label>Tipo</label>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-2">

                    <div class="col-12">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="eventTypeSelected">
                            <option v-for="tipo in eventTypes" :key="tipo.event_type_id"
                                :value="{ id: tipo.event_type_id, text: tipo.event_type }">{{
                                    tipo.event_type
                                }}</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="visible">
                            <label class="form-check-label" for="flexCheckDefault">
                                Visible
                            </label>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                v-model="dynamic">
                            <label class="form-check-label" for="flexCheckDefault">
                                Dinámico
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row d-flex align-items-center mb-1">

                    <div class="col-12">
                        <label>Alcance</label>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3">
                    <div class="col-12">
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedScope">
                            <option v-for="alc in alcances" :key="alc">{{ alc }}</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex align-items-center mb-3"> 
                    <div class="col-12">                     
                        <label>Estado</label>
                    </div>
                    <div class="col-12">                            
                        <select class="form-select form-select-sm" aria-label="Default select example"
                            v-model="selectedState">
                            <option v-for="est in estados" :key="est">{{ est }}</option>
                        </select>
                    </div>
                                  
                </div>

                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-2">
                        <label>Ubicación</label>
                    </div>

                    <div class="col-3 mb-1">
                        <label>Lat</label>
                    </div>

                    <div class="col-9">
                        <input class="form-control form-control-sm" type="text" id="lat" v-model="lat">
                    </div>

                    <div class="col-3">
                        <label>Lon</label>
                    </div>

                    <div class="col-9 mb-2">
                        <input class="form-control form-control-sm" type="text" id="lon" v-model="lon">
                    </div>

                    <div class="col-12">
                        <button class="btn btn-secondary btn-sm col-12" id="pasteCoords" @click="pasteCoords"><i
                                class="bi bi-pin-map-fill"></i></button>
                    </div>
                </div>
               
         </div>
      
            <div class="modal-body" v-if="isMobile">
                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-1">
                        <label>Descripción</label>
                    </div>

                    <div class="col-12">
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                            v-model="descript"></textarea>
                    </div>
                </div>

                <div class="w-100 mt-3">
                    <file-uploader ref="fileUploaderRef" :show-upload-button="false" :destPath="destPath"></file-uploader>
                </div>
                
                <div class="row">
                    <div class="col-12">
                        <label>Medios asociados</label>
                        <div v-if="eventAttachments.length > 0" class="row tbl-container">
                            <div class="table-wrapper">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th></th> <!-- Columna para los íconos -->
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="media in eventAttachments" :key="media.id_event_attachment">
                                        <td><i class="bi bi-file-earmark"></i></td> <!-- Ícono para archivos -->
                                        <td>{{ media.file_name }}</td>
                                        <td>{{ formatUtc(media.utc) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <div v-else>
                            <p>No hay medios asociados.</p>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-12 justify-content-end d-flex">
                        
                        <button class="btn btn-danger" id="cancelar" @click="cancelar">Cancelar</button>
                        <button class="btn btn-success" id="aceptar" @click="saveEvent">Aceptar</button>
                    </div>
                </div>
            </div>

            </div>
      
        <!-- fin mobile -->

        <!-- FIN NEW EVENT FORM -->
    </BaseModal>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue' // Add computed here
import { useServicesStore } from '@/stores/services';
import { storeToRefs } from 'pinia';
import type { Evento, EventAttachment } from '@/types';
import { estados, alcances } from '@/staticData';
import API from "../services";
import { AxiosError } from "axios";
import BaseModal from './base/BaseModal.vue'
import { useAuthStore } from '../stores/t-auth'
import FileUploader from './FileUploader.vue';
import { useUtils } from '@/composables/useUtils';
import { useGlobalStore } from '@/stores/global';



// Crear la referencia del template
const fileUploaderRef = ref<InstanceType<typeof FileUploader> | null>(null);

    // Definiciones de variables y referencias
const auth = useAuthStore()
const { getMimeTypeFromExtension, formatUtc } = useUtils();

const datos = useServicesStore();
const { eventTypes } = storeToRefs(datos);

const globalStore = useGlobalStore();

const { coordinatesClipboard, isMobile } = storeToRefs(globalStore);

const state = ref(estados)
const scope = ref(alcances)
const destPath = ref('/events/AW')
const props = defineProps<{
    eventData: Evento
}>()
const emit = defineEmits<{
    (event: 'close'): void,
}>()


const fecha = ref('')
const hora = ref('')
const lat = ref(0)
const lon = ref(0)
const eventTypeSelected = ref({ id: 0, text: "" })
const selectedScope = ref("")
const selectedState = ref("")
const visible = ref(false)
const dynamic = ref(false)
const descript = ref("")
const eventAttachments = ref<EventAttachment[]>([]); 
const isSaving = ref(false);

onMounted(async () => {
    lat.value = props.eventData.location.coordinates[1]
    lon.value = props.eventData.location.coordinates[0]
    let tipoEvento = eventTypes.value.find(tipo => tipo.event_type === props.eventData.type)
    if (tipoEvento) {
        eventTypeSelected.value = { id: tipoEvento.event_type_id, text: tipoEvento.event_type }
    }
    // Asignar el valor correcto de alcance y estado usando el texto del evento
    selectedScope.value = alcances.find(a => a === props.eventData.scope) || ""
    selectedState.value = estados.find(e => e === props.eventData.state) || ""
     // Asignar fecha y hora desde utc del evento
    if (props.eventData.utc) {
        const [fechaStr, horaStr] = props.eventData.utc.split(' ');
        fecha.value = fechaStr;
        hora.value = horaStr ? horaStr.split(':').slice(0,2).join(':') : '';
    }
    descript.value = props.eventData.description || ""
    visible.value = props.eventData.user_visible === 1
    fetchEventAttachments(props.eventData.event_number);
    
})


let ahora = new Date()
//console.log(ahora.toLocaleDateString())
fecha.value = ahora.toISOString().split('T')[0]
hora.value = ahora.toISOString().split('T')[1].split('.')[0]


async function saveEvent() {
    isSaving.value = true;
    console.log('Guardando evento...')
    let unitId = "AW";
   
    if (globalStore.patrulla.unitId && globalStore.patrulla.unitId !== "") {
        unitId = globalStore.patrulla.unitId.substring(0, 2);
        
    }
    let input = {
        record_unit: props.eventData.record_unit,
        utc: fecha.value + ' ' + hora.value,
        event_number: props.eventData.event_number,
        event_unit: unitId,
        type: eventTypeSelected.value.text,
        description: descript.value,
        mission: props.eventData.mission,
        reference: props.eventData.reference,
        location_lat: lat.value,
        location_lon: lon.value,
        state: selectedState.value,
        scope: selectedScope.value,
        visible: (visible.value) ? 1 : 0,
        data: descript.value,
        json: "",
        user_id: auth.logedUser,
    }

    try {
        const { status, data } = await API.putEvent(input);

        if (status === 200) {
            const nuevoEvento = {
                event_id: data.Entries.Entry.event_id,
                record_number: data.Entries.Entry.record_number,
                record_unit: input.record_unit,
                utc: input.utc,
                event_number: input.event_number,
                event_unit: input.event_unit,
                type: input.type,
                description: input.description,
                mission: input.mission,
                reference: input.reference,
                location: {
                    type: "Point",
                    coordinates: [input.location_lon, input.location_lat] as [number, number]
                },
                state: input.state,
                scope: input.scope,
                user_visible: 1,
                data: input.data,
                json: input.json,
                user_id: input.user_id,
            };
            
            // Agregar el evento al inicio del array global
            datos.events.unshift(nuevoEvento);
            
            // Subir archivos si hay alguno seleccionado
            if (fileUploaderRef.value && fileUploaderRef.value.files.length > 0) {
                try {
                    // Obtener el año y el mes actuales
                    const now = new Date();
                    const currentYear = now.getFullYear();
                    const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Mes en formato "MM"

                    destPath.value = '/events/' + currentYear + '/' + currentMonth + '/AW' + nuevoEvento.record_number;
                    console.log('Subiendo archivos con destPath:', destPath.value);
                    await fileUploaderRef.value.uploadAllFiles();
                    console.log('Archivos subidos exitosamente');

                    for (const file of fileUploaderRef.value.files) {
                        const attachmentInput = {
                            event_id: nuevoEvento.event_id,
                            utc: nuevoEvento.utc,
                            file_name: file.file.name,
                            file_path: destPath.value + '/' + file.file.name,
                            mime_type: getMimeTypeFromExtension(file.file.name.split('.').pop() || ''),
                            file_ext: file.file.name.split('.').pop() || '',
                            user_id: auth.logedUser,
                        };

                        try {
                            await API.createEventAttachment(attachmentInput);
                            console.log(`Archivo ${file.file.name} asociado al evento correctamente.`);
                        } catch (error) {
                            console.error(`Error al asociar el archivo ${file.file.name}:`, error);
                        }
                    }
                } catch (error) {
                    console.error('Error al subir archivos:', error);
                }
            }
            
            emit('close')
            console.log('Evento y archivos guardados OK: ')
        }
    } catch (error) {
        const _error = error as AxiosError<string>;
        emit('close')
        console.log('Error: ' + _error)
    }
}
async function fetchEventAttachments(eventId: number) {
  try {
    const response = await API.getEventAttachments(eventId);
    eventAttachments.value = response.data.Entries.Entry || [];
    console.log('Adjuntos del evento:', eventAttachments.value);
  } catch (error) {
    console.error('Error al obtener los adjuntos del evento:', error);
  }
}
function cancelar() {
    emit('close');
    if (isMobile.value) {
        emit('close');
    }
}



function setAhora() {
    const ahora = new Date();
    fecha.value = ahora.toISOString().split('T')[0];
    hora.value = ahora.toISOString().split('T')[1].split('.')[0];
}
function pasteCoords() {
    if (coordinatesClipboard.value) {
        lat.value = coordinatesClipboard.value.lat;
        lon.value = coordinatesClipboard.value.lon;
    }
}
</script>
<style lang="css" scoped>
.modalr {
    position: fixed;
    top: 350px;
    left: 350px;
    z-index: 15;

}

.modal-body {
    padding-left: 10px;
}

.modal-container {
        min-width: 440px;
}

.modal-content {
    background-color: #0003;
    backdrop-filter: blur(5px);
    border: 1px solid #9f9f9f36;
    color: #ffffff;
   
}

tbody {
  max-height: 100%;
  overflow-y: scroll;
}

.tbl-container {
    margin-left: 0;
    width: 100%;
    max-height: 35vh; /* Altura máxima del contenedor */
    overflow-y: auto; /* Habilitar scroll vertical */
    border: 1px solid #ccc; /* Borde para delimitar el área */
}

.table>:not(caption)>*>* {
    background-color: #00000000;
    color: #ffffff;
    font-size: 12px;}



@media (max-width: 576px) {
    label {
        font-size: 1em;
        margin-bottom: 5px;
    }
    .modal-container {
        min-width: calc(100% - 20px);
        width: calc(100% - 20px);
    }
    .col-12 .form-select-sm {
        width: 100%;
    }
    .form-check .form-check-input {
        height: 1.5em;
        width: 1.5em;
    }
    .form-check-label{
        font-size: 1em;
        margin-left: 1em;
    }

}

</style>